module.exports = __webpack_public_path__ + "static/greyelephant-d020b077f1fc59d2d54256c42ddac64d.png";